export const IDTR_URL =
  "https://www.identitytheft.gov/confirmation/genericsteps";
export const IDTR_BLANK_PAGES = 2;

export const IDTR_TEXT = {
  agency: "FEDERAL TRADE COMMISSION",
  reportNumberLabel: "FTC Report Number:",
  intro:
    "I am a victim of Identity theft. This is my official statement about the crime.",
  contactTitle: "Contact Information",
  statementTitle: "Personal Statement",
  accountsTitle: "Accounts Affected by the Crime",
  fraudTitle: "Fraudulent Information on Credit Reports",
  firstName: "First Name:",
  lastName: "Last Name:",
  address: "Address:",
  country: "USA",
  phone: "Phone:",
  email: "Email:",
  company: "Company or Organization:",
  accountNumber: "Account Number:",
  dateBegan: "Date fraud began:",
  dateDiscovered: "Date that I discovered it:",
  amount: "Total fraudulent amount:",
  accountsOrCharges: "Accounts or Charges",
  accountsOrChargesValue:
    "Yes, fraudulent accounts or charges appear on my credit report",
  creditInquiries: "Credit Inquiries",
  perjuryTitle:
    "Under penalty of perjury, I declare this information is true and correct to the best of my knowledge.",
  perjuryText:
    "I understand that knowingly making any false statements to the government may violate federal, state, or local criminal statutes, and may result in a fine, imprisonment, or both.",
  dateLabel: "Date",
  note: "Use this form to prove to businesses and credit bureaus that you have submitted an FTC Identity Theft Report to law enforcement. Some businesses might request that you also file a report with your local police.",
};

export const IDTR_TEMPLATES = [
  {
    key: "auto-loan",
    name: "Auto Loan",
    accountTitle: "Fraudulent Auto Loan or Lease",
    statement:
      "Currently reporting to my credit report is a fraudulent auto loan that is the work of a credit thief.",
    defaultAccounts: 1,
    hasInquiries: false,
  },
  {
    key: "collection",
    name: "Collection",
    accountTitle: "Other Identity Theft",
    statement:
      "Currently reporting to my credit report is a fraudulent collection that is the work of a credit thief.",
    defaultAccounts: 1,
    hasInquiries: false,
  },
  {
    key: "credit-card",
    name: "Credit Card loan",
    accountTitle: "Credit Card Opened by the Thief",
    statement:
      "Currently reporting to my credit report are several fraudulent credit cards that are the work of a credit thief.",
    defaultAccounts: 3,
    hasInquiries: false,
  },
  {
    key: "credit-inquiries",
    name: "Credit Inquiries",
    accountTitle: "Credit Card Opened by the Thief",
    statement:
      "Currently reporting to my credit report are several fraudulent inquiries that are the work of a credit thief. Additional fraudulent inquiries are the following:",
    defaultAccounts: 1,
    hasInquiries: true,
  },
  {
    key: "personal-loan",
    name: "Personal or Business loan",
    accountTitle: "Fraudulent Personal or Business Loan",
    statement:
      "Currently reporting to my credit report are several fraudulent personal loans that are the work of a credit thief.",
    defaultAccounts: 3,
    hasInquiries: false,
  },
  {
    key: "real-estate",
    name: "Real Estate",
    accountTitle: "Fraudulent Real Estate Loan",
    statement:
      "Currently reporting to my credit report are several fraudulent real estate loans that are the work of a credit thief.",
    defaultAccounts: 3,
    hasInquiries: false,
  },
  {
    key: "student-loan",
    name: "Student Loan",
    accountTitle: "Fraudulent Federal Student Loan",
    statement:
      "Currently reporting to my credit report is a fraudulent student loan that is the work of a credit thief.",
    defaultAccounts: 1,
    hasInquiries: false,
  },
];

export const getIdtrTemplate = (key) =>
  IDTR_TEMPLATES.find((item) => item.key === key) || null;

// A Cover Letter Template is linked to a report template by its `idtr_template` field,
// set on the Letter Template page. Without it there is no report for that template.
export function resolveIdtrTemplateKey(letterTemplate) {
  const key = letterTemplate && letterTemplate.idtr_template;
  return key && getIdtrTemplate(key) ? key : null;
}
